import { render, staticRenderFns } from "./PriceTemplateUpdate.vue?vue&type=template&id=e48a7cb4"
import script from "./PriceTemplateUpdate.vue?vue&type=script&lang=ts"
export * from "./PriceTemplateUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports